export { default } from './Rating';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/Rating/index.js
// module id = 374
// module chunks = 0